$(document).ready(function() {
    // Función para cerrar todos los modales
    function closeAllModals() {
        $('.modal').hide();
        $('html').removeClass('u-scroll-block'); // Quitar clase modal-open al body
    }

    // Abrir modal correspondiente
    $('[data-modal-target]').click(function() {
        var modalId = $(this).data('modal-target');
        closeAllModals();
        $('#' + modalId).css('display', 'flex'); // Mostrar con display flex
        $('html').addClass('u-scroll-block'); // Añadir clase modal-open al body
    });

    // Cerrar modal correspondiente
    $('[data-modal-close]').click(function() {
        var modalId = $(this).data('modal-close');
        $('#' + modalId).hide();
        $('html').removeClass('u-scroll-block'); // Quitar clase modal-open al body
    });

    // Cerrar modal si el usuario hace clic fuera del contenido del modal
    $(window).click(function(event) {
        $('.modal').each(function() {
            if (event.target === this) {
                $(this).hide();
                $('html').removeClass('u-scroll-block'); // Quitar clase modal-open al body
            }
        });
    });
});
